import script from "./ResetPasswordLayout.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordLayout.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__